exports.routes = {
    login: `/admin/login`,
    profile: `/admin/profile`,
    changePassword: `/admin/change-password`,
    dashboard: `/admin/dashboard`,
    userManagement: `/admin/user-management`,
    userManagementDetail: `/admin/user-management/info`,
    provider: `/admin/provider`,
    providerDetails: `/admin/provider/info`,
    providerRegistration: `/admin/provider/registration-request`,
    jobOpportunities: `/admin/posted-job-opportunities`,
    jobOpportunityDetail: `/admin/posted-job-opportunities/info`,
    advertisement: `/admin/advertisement`,
    advertisementDetails: `/admin/advertisement/info`,
    careJob: `/admin/care-job`,
    careJobDetails: `/admin/care-job/info`,
    careAssessment: `/admin/care-assessment`,
    moreProvider: `/admin/care-assessment/more-provider`,
    careAssessmentDetail: `/admin/care-assessment/info`,
    careAssessmentRequest: `/admin/care-assessment/care-provider-requests`,
    manageSubscriptionPlan: `/admin/manage-subscription-plan`,
    paymentLogs: `/admin/payment-logs`,
    master: `/admin/cms`,
    manageEmployee: `/admin/employee-management`,
    manageNewsletter: `/admin/manage-newsletter`,
    manageCoupon: `/admin/manage-coupon`,
}